import { boolean, mixed, object, string } from 'yup';

import { TemplateFrequency } from '../../../../../data/types/api/graphql';
import { messages, trim } from '../../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    healthProfessionalId: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    templateId: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    frequency: mixed<TemplateFrequency>()
      .oneOf(Object.values(TemplateFrequency))
      .required(messages.required.id)
      .default(TemplateFrequency.Once),
    startDate: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    endDate: string()
      .transform(trim)
      .when('frequency', {
        is: (frequency: TemplateFrequency) =>
          frequency !== TemplateFrequency.Once,
        then: currentSchema => currentSchema.required(messages.required.id),
      })
      .default(''),
    overwrite: boolean().nullable().default(false),
  })
  .required()
  .noUnknown();
